import { motion } from "framer-motion";
import { fadeUp } from "@/lib/motion";

export const Reveal = ({ children, i = 0, className = "", as = "div" }) => {
  const M = motion[as] || motion.div;
  return (
    <M
      className={className}
      variants={fadeUp}
      custom={i}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-80px" }}
    >
      {children}
    </M>
  );
};
